import { IRequestBody } from './types.ts';
import { FeedBack } from '@/utils/feed_back.ts'
import { SERVER_TYPE, DEBUG_ENV, API_URL, KEEP_STORE_NAME, DEFAULT_ANTI_SPIDER, CHANNEL_TYPE, SM_SERVER_TYPE, SDK_VERSION, METRIC_NAME_F, METRIC_NAME_COMMON_INFO_CHANGED } from '@/constants/index.ts';
import { generateMonitorReport } from '@shein-aidc/monitor-core/monitor-report';
import sdkInit, { provider } from './init';
import verify from './verify';
import GlobalVariables, { GLOBAL_VARIABLES } from '@/utils/global.ts';
import { AxiosResponse } from 'axios';
import { rewriteFetch, rewriteXHR, fetchJsonSafe } from '@/utils';
import logUtils from '@/utils/logUtils.ts';

export class AntiSpiderManager {
  private static instance: AntiSpiderManager;
  private feedback: FeedBack | any = null;
  private server_type: keyof typeof SERVER_TYPE.production = 'central'; //数据中心
  private env: keyof typeof DEBUG_ENV = 'production'; //环境
  private headers: object = {}; //请求头
  private keep_store: boolean = true //是否允许存储
  private brand: 'shein' | 'romwe' = 'shein' //品牌
  private currency: string = 'USD' //货币
  private language: string = 'en' //语言
  private device_type: 'pc' | 'h5' | 'pwa' = 'pc' //设备类型
  private site_id: string = '' //品牌ID
  private site_from: string = '' //站点
  // private api_paths: string[] = ['/bff-api', '/api', '/risk'] //请求路径
  private sdks: string[] = [] //sdk
  private validate_channel: string = '0' //验证通道
  private validate_scene: string = 'anti_crawler_RT' //验证场景
  // private limit_init_count: number = 0 //限制初始化次数
  private limit_init_max: number = 1 //限制初始化最大次数
  private cancel_sdks_headers: string[] = [] // 需要排除的请求头
  private site_id_slim: string = '' // 站点细分
  private pay_collection: string[] = ['forter', 'cybersource', 'riskified'] // 支付集合
  private store_data: any = {};
  private constructor() { }
  public init(options: IRequestBody) {
    window.__limit_init_count = (window.__limit_init_count || 0) + 1;
    const { validate_channel = '0', validate_param } = options
    if (!validate_param?.server_type || !validate_param?.site_id || !validate_param?.site_from || !validate_param?.language) return;
    this.server_type = validate_param?.server_type || this.server_type;
    this.env = validate_param?.env || this.env;
    this.keep_store = validate_param?.keep_store || this.keep_store;
    this.currency = validate_param?.currency || this.currency;
    this.language = validate_param?.language || this.language;
    this.device_type = CHANNEL_TYPE[validate_channel] || this.device_type;
    this.site_id = validate_param?.site_id || this.site_id;
    this.site_from = validate_param?.site_from || this.site_from;
    this.brand = validate_param?.brand || this.brand;
    this.validate_channel = validate_channel;
    this.headers = validate_param?.headers || this.headers;
    this.site_id_slim = validate_param?.site_id_slim || this.site_id_slim;
    // if (Array.isArray(validate_param?.api_paths)) {
    //   this.api_paths = Array.from(new Set([...this.api_paths, ...validate_param?.api_paths]));
    // }
    this.sdks = validate_param?.sdks || this.sdks;
    this.cancel_sdks_headers = validate_param?.cancel_sdks_headers || this.cancel_sdks_headers;
    GlobalVariables.set(GLOBAL_VARIABLES.ENV, this.env);
    // GlobalVariables.set(GLOBAL_VARIABLES.API_PATHS, this.api_paths);
    GlobalVariables.set(GLOBAL_VARIABLES.CHANNEL, this.validate_channel);

    let store_data: any = {};
    try {
      store_data = JSON.parse(window?.localStorage?.getItem(KEEP_STORE_NAME) as string) || DEFAULT_ANTI_SPIDER;
      GlobalVariables.set(GLOBAL_VARIABLES.ANTI_HIT, store_data?.anti_in?.hit || []);
      GlobalVariables.set(GLOBAL_VARIABLES.CS_HIT, store_data?.csrandom?.hit || []);
    } catch (error) {
      console.log('localStorage parse error', error);
      store_data = DEFAULT_ANTI_SPIDER
    }
    this.store_data = store_data
    this.initLog();
    this.initH5InfpAndSm();
    this.initXHRAndFetch(this.cancel_sdks_headers, this.sdks);
    this.loadScripts(store_data, validate_channel);
    this.loadSDK();
  }

  private initLog() {
    const { metric } = generateMonitorReport(
      {
        app_name: this.brand,
        device_type: this.device_type,
        sub_site: this.site_from,
        money_type: this.currency,
        language: this.language,
        environment: this.env === 'production' ? 'production' : 'debug'
      },
      {
        server_type: this.server_type
      }
    )
    GlobalVariables.set(GLOBAL_VARIABLES.METRIC, metric);
  }

  private initXHRAndFetch(_headers: string[], _sdks: string[]) {
    if (window.__limit_init_count > this.limit_init_max) {
      logUtils.info('Initialization limit reached', `Current: ${window.__limit_init_count}  Max: ${this.limit_init_max} Please check for repeated initializations.`);
      return;
    };
    rewriteXHR(_headers, _sdks)
    rewriteFetch(_headers, _sdks)
  }

  private async loadSDK() {
    const time = Date.now();
    const url = `${SERVER_TYPE[this.env][this.server_type]}${API_URL.VALIDATION_ANTI_SPIDER}`;
    const params = {
      v: SDK_VERSION,
      sdk: this.sdks,
      site_id: this.site_id,
      site_from: this.site_from,
      channel: this.validate_channel,
      scene: this.validate_scene
    };
    try {
      const { response, status } = await fetchJsonSafe(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(params)
      });
      if (response?.code === '0') {
        window?.localStorage?.setItem(KEEP_STORE_NAME, JSON.stringify(response?.info || {}));
        GlobalVariables.set(GLOBAL_VARIABLES.ANTI_HIT, response?.info?.anti_in?.hit || []);
        GlobalVariables.set(GLOBAL_VARIABLES.CS_HIT, response?.info?.csrandom?.hit || []);
      }
      GlobalVariables.get(GLOBAL_VARIABLES.METRIC)?.({
        metric_name: METRIC_NAME_F,
        tags: { url, status, type: 'loadSDK', ...params },
        value: Date.now() - time,
        message: 'spider load success',
      })
    } catch (error: any) {
      GlobalVariables.get(GLOBAL_VARIABLES.METRIC)?.({
        metric_name: METRIC_NAME_F,
        tags: { url, status: error?.status, type: 'loadSDKError', ...params },
        value: Date.now() - time,
        message: 'spider load error',
        params: error
      })
    }
  }

  public doVerify(options: IRequestBody) {
    const { validate_param, validate_type } = options
    if (!validate_type) return;
    this.headers = validate_param?.headers || this.headers;
    const obj = {
      baseURL: `${SERVER_TYPE[this.env][this.server_type]}`,
      site_id: this.site_id,
      site_from: this.site_from,
      language: this.language,
      headers: this.headers,
      keep_store: this.keep_store,
      validate_type,
      validate_scene: this.validate_scene,
      validate_channel: this.validate_channel,
      validate_param: validate_param || {},
      cookie_duration: validate_param?.cookie_duration || 0
    }
    return verify(obj)
  }

  private async loadScripts(data: any, channel: string) {
    window['_INCONF'] = {
      appName: this.brand,
      apiHost: `${SERVER_TYPE[this.env][this.server_type]}`,
      channel,
      isOpenIntervalReport: false,
      isOpenFeatureDector: false,
      onsuccess: () => {
        const armorToken = window?.AntiDevices?.getArmorToken()
        if (armorToken) {
          window.__ArmorToken = armorToken
          window?.sessionStorage?.setItem('armorToken', armorToken)
          window?.localStorage?.setItem('armorToken', armorToken)
        }
      }
    }
    window['_smConf'] = {
      organization: 'FPNyuLhAtVnAeldjikus',
      isOpenUserBehavior: false,
      apiHost: `${SM_SERVER_TYPE[this.env][this.server_type]}/risk/verify/identity/validation/devices`,
    }
    const needLoadSDK = {} as typeof import('@/constants')['DEFAULT_ANTI_SPIDER']
    if (Array.isArray(this.sdks) && this.sdks.length > 0) {
      // // 支付不参与初始化JS加载
      // const filteredSdks = this.sdks.filter(s => !this.pay_collection.includes(s));
      // filteredSdks.forEach((sdk: string) => {
      this.sdks.forEach((sdk: string) => {
        if (data[sdk]) {
          needLoadSDK[sdk] = data[sdk]
        }
      })
    }
    sdkInit(needLoadSDK, { server_type: this.server_type, env: this.env, site_from: this.site_from, brand: this.brand, channel });
  }
  public antiSpiderInterceptor() {
    if (!AntiSpiderManager.instance.feedback) {
      const anti_spider = {
        name: 'anti_spider',
        active: () => true,
        range: () => true,
        check: ({ data }) => data?.code == 836100 && data?.sub_code && data?.attachment?.cookie_duration,
        fix: (r: AxiosResponse) => this.runFlowChallenge(r.data.sub_code, r.data.attachment.cookie_duration, r?.headers?.['risk-id'])
          .then((data: any) => { if (data.status !== 'success') { throw data } }),
      }
      AntiSpiderManager.instance.feedback = new FeedBack([anti_spider]);
    }
    return AntiSpiderManager.instance.feedback.interceptor;
  }

  private runFlowChallenge(captcha_type: string, cookie_duration: string, api_risk_id: string) {
    const obj = {
      baseURL: `${SERVER_TYPE[this.env][this.server_type]}`,
      site_id: this.site_id,
      site_from: this.site_from,
      language: this.language,
      validate_type: captcha_type,
      validate_scene: this.validate_scene,
      validate_channel: this.validate_channel,
      validate_param: {
        decision_id: api_risk_id || '',
      },
      headers: this.headers || {},
      cookie_duration,
      site_id_slim: this.site_id_slim
    }
    return verify(obj)
  }

  private async initH5InfpAndSm() {
    if (this.validate_channel == '0' || this.validate_channel == '1') return;
    //h5
    window._s_ArmorToken = await provider.armortoken();
    window._s_SmDeviceId = await provider.smdeviceid();
    try {
      // 监听app headers动态数据变化 app版本 8.8.0 以下不支持
      window?.document?.addEventListener("commonInfoChanged", (data: any = {}) => {
        const time = Date.now();
        const params = data.detail || data.param || data || {}
        if (params?.smDeviceId) {
          window._s_SmDeviceId = params?.smDeviceId
        }
        if (params?.armorToken) {
          window._s_ArmorToken = params?.armorToken
        }
        GlobalVariables.get(GLOBAL_VARIABLES.METRIC)?.({
          metric_name: METRIC_NAME_COMMON_INFO_CHANGED,
          tags: { type: 'cic', from: 'document' },
          value: Date.now() - time,
          message: 'commonInfoChanged',
          params: data
        })
      });

      // 监听app headers动态数据变化 app版本 8.8.0 以下不支持
      window?.addEventListener("commonInfoChanged", (data: any = {}) => {
        const time = Date.now();
        const params = data.detail || data.param || data || {}
        if (params?.smDeviceId) {
          window._s_SmDeviceId = params?.smDeviceId
        }
        if (params?.armorToken) {
          window._s_ArmorToken = params?.armorToken
        }
        GlobalVariables.get(GLOBAL_VARIABLES.METRIC)?.({
          metric_name: METRIC_NAME_COMMON_INFO_CHANGED,
          tags: { type: 'cic', from: 'window' },
          value: Date.now() - time,
          message: 'commonInfoChanged',
          params: data
        })
      });
    } catch (error) {
      const time = Date.now();
      GlobalVariables.get(GLOBAL_VARIABLES.METRIC)?.({
        metric_name: METRIC_NAME_COMMON_INFO_CHANGED,
        tags: { type: 'cic', from: 'error' },
        value: Date.now() - time,
        message: 'commonInfoChanged',
        params: error
      })
    }
  }

  public async antiBlackbox() {
    return provider.blackbox({ validate_channel: this.validate_channel, brand: this.brand })
  }

  public async antiSmdeviceid() {
    return provider.smdeviceid()
  }

  public async antiArmortoken() {
    return provider.armortoken()
  }

  public async antiin() {
    return provider.antiin()
  }

  public antiCybersource() {
    return provider.antiCybersource()
  }

  public antiForter() {
    return provider.antiForter()
  }

  public antiForterSiteId() {
    return provider.antiForterSiteId()
  }

  public antiRiskified() {
    return provider.antiRiskified()
  }

  public async antiPayGroup() {
    // this.antiPaySDK()
    const blackbox = await this.antiBlackbox();
    return {
      forterDeviceFingerprintID: this.antiForter(),
      forterSiteId: this.antiForterSiteId(),
      riskifiedDeviceFingerprintID: this.antiRiskified(),
      deviceFingerId: this.antiCybersource(),
      blackbox
    }
  }

  public antiPaySDK() {
    const needLoadSDK = {} as typeof import('@/constants')['DEFAULT_ANTI_SPIDER']
    if (Array.isArray(this.pay_collection) && this.pay_collection.length > 0) {
      this.pay_collection.forEach((sdk: string) => {
        if (this.store_data[sdk]) {
          needLoadSDK[sdk] = this.store_data[sdk]
        }
      })
    }
    sdkInit(needLoadSDK, { server_type: this.server_type, env: this.env, site_from: this.site_from });
  }

  public static getInstance() {
    if (!AntiSpiderManager.instance) {
      AntiSpiderManager.instance = new AntiSpiderManager();
    }
    return AntiSpiderManager.instance;
  }
}

export default AntiSpiderManager.getInstance();
const init = AntiSpiderManager.getInstance().init.bind(AntiSpiderManager.getInstance());
const doVerify = AntiSpiderManager.getInstance().doVerify.bind(AntiSpiderManager.getInstance());
const antiSpiderInterceptor = AntiSpiderManager.getInstance().antiSpiderInterceptor.bind(AntiSpiderManager.getInstance());
const antiBlackbox = AntiSpiderManager.getInstance().antiBlackbox.bind(AntiSpiderManager.getInstance());
const antiin = AntiSpiderManager.getInstance().antiin.bind(AntiSpiderManager.getInstance());
const antiCybersource = AntiSpiderManager.getInstance().antiCybersource.bind(AntiSpiderManager.getInstance());
const antiForter = AntiSpiderManager.getInstance().antiForter.bind(AntiSpiderManager.getInstance());
const antiForterSiteId = AntiSpiderManager.getInstance().antiForterSiteId.bind(AntiSpiderManager.getInstance());
const antiRiskified = AntiSpiderManager.getInstance().antiRiskified.bind(AntiSpiderManager.getInstance());
const antiPayGroup = AntiSpiderManager.getInstance().antiPayGroup.bind(AntiSpiderManager.getInstance());
const antiPaySDK = AntiSpiderManager.getInstance().antiPaySDK.bind(AntiSpiderManager.getInstance());

export {
  init,
  doVerify,
  antiSpiderInterceptor,
  antiBlackbox,
  antiin,
  antiCybersource,
  antiForter,
  antiForterSiteId,
  antiRiskified,
  antiPayGroup,
  antiPaySDK
}
